// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b070w{max-width:700px;margin-bottom:24px;align-items:flex-start;width:100%}.njniS{display:inline-flex;margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `b070w`,
	"saveButtonWrapper": `njniS`
};
export default ___CSS_LOADER_EXPORT___;
